import { FaUserGraduate } from "react-icons/fa";
import { TbCertificate } from "react-icons/tb";
import { PiCatFill } from "react-icons/pi";

import cat from "../../assets/cat.jpg";
import "./about-me.css";
import { SectionProps, Sections } from "../../App";

const AboutMe = ({ observeElement }: SectionProps) => {
  return (
    <section id={Sections.ABOUT_ME}>
      <h2>About me</h2>
      <div className="container about__container">
        <div className="about__image">
          <img src={cat} alt="huihui" />
        </div>

        <div className="about__content" ref={observeElement}>
          <div className="about__cards">
            <article className="about__card">
              <FaUserGraduate className="about__icon about__icon-grad" />
              <h5>Computer Science</h5>
              <small>National University of Singapore (NUS)</small>
            </article>
            <article className="about__card">
              <TbCertificate className="about__icon" />
              <h5>Focus Area</h5>
              <small>Software Engineering, Database Systems</small>
            </article>
            <article className="about__card">
              <PiCatFill className="about__icon" />
              <h5>Number of cats</h5>
              <small>3</small>
            </article>
          </div>

          <p>
            {"Welcome to my site! I am Yu Qi, a Software Engineer " +
              "with experience building systems used by people around " +
              "the world."}
            <br></br>
            <br></br>
            {"I am always open to fun software engineering projects so "}
            <b>{"DM me and let's work together!"}</b>
          </p>

          <a href="#contact" className="btn btn-primary">
            DM me!
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
